import React from 'react';
import { Columns } from '@components/Columns';
import { Flex } from '@components/Flex';
import {
  ButtonsContainer,
  HeroVideoContainer,
  HeroVideoWrapper,
  HeroVideoOverlay,
  RegistryHeroTextColumn,
  StyledSection,
  StyledButton,
  StyledGetStartedButton,
} from '@sections/registry/HeroSectionV0/HeroSectionV0.styles';
import { registryPageData } from '@data-ts/pages/registry';
import { getRootUrl } from '@utils/urlHelpers.util';
import { getCreateWeddingUrl } from '@utils/urlHelpers.util';
import { VimeoVideo } from '@components/VimeoVideo';
import { ValuePropsSection } from '@components/ValuePropsSection';
import { PropsSlider } from './Components/PropsSlider/PropsSlider';
import { HERO_VIDEO_URL, WEDDING_REGISTRY_VALUE_PROPS } from './HeroSectionV0.constants';
import { Integrations } from '@static/js/types';

const analytics = require('../../../../static/js/joy');

const registryHeroData = registryPageData.hero;
interface HeroSectionProps {}

export const HeroSectionV0: React.FC<HeroSectionProps> = () => {
  const onValuePropClicked = (e: React.MouseEvent, url: string, name: string) => {
    e.preventDefault();
    analytics.segment.sendTelemetryEvent(`newmarketing.registryHeroValuePropClicked`, { label: name }, undefined, {
      integrations: { [Integrations.Amplitude]: true },
    });
    window.open(url, '_blank');
  };

  return (
    <>
      <StyledSection as="section" id="Registry_Hero">
        <HeroVideoContainer>
          <HeroVideoWrapper>
            <HeroVideoOverlay />
            <VimeoVideo
              posterUrl="registry-v2/registry-hero/registry-hero-static-v3.jpg"
              embedUrl={HERO_VIDEO_URL}
              title="Registry Hero"
              autoPlay
              background
              controls={false}
              autoPause={false}
              muted
              loop
              cover
            />
          </HeroVideoWrapper>
        </HeroVideoContainer>
        <RegistryHeroTextColumn verticalAlign="center">
          <Columns.Column width={12}>
            <Flex flexDirection={'column'} alignItems={'center'}>
              <PropsSlider />
              <ButtonsContainer>
                <StyledGetStartedButton
                  id="registryHeroGetStartedBtn"
                  variant="secondary"
                  forwardedAs={'a'}
                  href={getCreateWeddingUrl('registry')}
                >
                  {registryHeroData.getStarted}
                </StyledGetStartedButton>
                <StyledButton id="registryHeroFindCoupledBtn" variant="darkfindACoupleBtn" forwardedAs={'a'} href={getRootUrl('/find')}>
                  {registryHeroData.findAnEvent}
                </StyledButton>
              </ButtonsContainer>
            </Flex>
          </Columns.Column>
        </RegistryHeroTextColumn>
      </StyledSection>
      <ValuePropsSection values={WEDDING_REGISTRY_VALUE_PROPS} onClick={onValuePropClicked} />
    </>
  );
};
